<template>
  <div class="container">
    <div class="filter-container">
      <el-select
          v-model="queryField"
          class="filter-item"
          style="width: 120px"
          size="mini"
          @change="queryValue = ''"
      >
        <el-option label="ISSN" value="StrISSN"/>
        <el-option label="正题名" value="StrPositiveTitle"/>
      </el-select>
      <el-input
          v-model="queryValue"
          class="filter-item"
          style="width: 200px"
          size="mini"
          :placeholder="queryField === 'StrISSN' ? 'ISSN' : '正题名'"
          clearable
          @keydown.enter.native="handleFilter"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" size="mini" @click="handleFilter">查询</el-button>
      <el-button class="filter-item" size="mini" @click="resetFilter">重置</el-button>
      <el-button
          class="filter-item"
          type="success"
          icon="el-icon-plus"
          size="mini"
          @click="handleCreate"
      >添加</el-button>
    </div>

    <el-table
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%;"
    >
      <el-table-column label="正题名" min-width="200" show-overflow-tooltip>
        <template v-slot="{row}">
          <span>{{ row.StrPositiveTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column label="ISSN" width="120" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrISSN }}</span>
        </template>
      </el-table-column>
      <el-table-column label="CN号" width="120" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrCN }}</span>
        </template>
      </el-table-column>
      <el-table-column label="条码号" width="130" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrBarcode }}</span>
        </template>
      </el-table-column>
      <el-table-column label="书架名称" min-width="120" show-overflow-tooltip>
        <template v-slot="{row}">
          <span>{{ row.StrBookshelfName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="出版社" min-width="140" show-overflow-tooltip>
        <template v-slot="{row}">
          <span>{{ row.StrPublisher }}</span>
        </template>
      </el-table-column>
      <el-table-column label="出版年份" width="90" align="center">
        <template v-slot="{row}">
          <span>{{ row.IntPublicationYear }}</span>
        </template>
      </el-table-column>
      <el-table-column label="总价(元)" width="90" align="center">
        <template v-slot="{row}">
          <span>{{ row.FloatTotalPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column label="复本量" width="70" align="center">
        <template v-slot="{row}">
          <span>{{ row.IntNumberCopies }}</span>
        </template>
      </el-table-column>
      <el-table-column label="编目时间" width="160" align="center">
        <template v-slot="{row}">
          <span>{{ formatDate(row.DTCreatedDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          width="160"
          class-name="small-padding fixed-width"
          fixed="right"
      >
        <template v-slot="{row}">
          <el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top:50px;text-align:right;">
      <el-pagination
          background
          :total="total"
          :current-page="listQuery.Page"
          :page-size="listQuery.Perpage"
          :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
          layout="prev,pager,next,jumper,sizes,total"
          @size-change="pageSizeChange"
          @current-change="currPageChange"
      />
    </div>

    <!-- 过刊编目新增/编辑 -->
    <el-dialog
        :title="textMap[dialogStatus]"
        width="60%"
        v-model="dialogFormVisible"
        :close-on-click-modal="false"
    >
      <el-form
          ref="dataForm"
          :rules="rules"
          :model="formModel"
          label-width="100px"
          size="small"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="ISSN" prop="StrISSN">
              <el-input
                  v-model="formModel.StrISSN"
                  placeholder="输满8位自动查询"
                  @input="handleIssnInput"
                  @blur="handleIssnBlur"
              >
                <template v-slot:suffix>
                  <i v-if="issnInfoLoading" class="el-icon-loading"></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="CN号" prop="StrCN">
              <el-input v-model="formModel.StrCN" placeholder="请输入CN号"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="总价" prop="FloatTotalPrice">
              <div style="display:flex;align-items:center">
                <el-input v-model="formModel.FloatTotalPrice" type="number" min="0" step="0.01" placeholder="总价" style="flex:1"/>
                <span style="margin-left:6px">元</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="正题名" prop="StrPositiveTitle">
              <el-input v-model="formModel.StrPositiveTitle" placeholder="请输入正题名"/>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="副题名" prop="StrSubtitle">
              <el-input v-model="formModel.StrSubtitle" placeholder="请输入副题名"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="并列题名" prop="StrParallelTitle">
              <el-input v-model="formModel.StrParallelTitle" placeholder="请输入并列题名"/>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="第一责任者" prop="StrFirstResponsible">
              <el-input v-model="formModel.StrFirstResponsible" placeholder="请输入第一责任者"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="第二责任者" prop="StrSecondResponsible">
              <el-input v-model="formModel.StrSecondResponsible" placeholder="请输入第二责任者"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="集体责任者" prop="StrCollectiveResponsible">
              <el-input v-model="formModel.StrCollectiveResponsible" placeholder="请输入集体责任者"/>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="出版地" prop="StrPublisherPlace">
              <el-input v-model="formModel.StrPublisherPlace" placeholder="请输入出版地"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出版社" prop="StrPublisher">
              <el-input v-model="formModel.StrPublisher" placeholder="请输入出版社"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出版年份" prop="IntPublicationYear">
              <div style="display:flex;align-items:center">
                <el-input v-model="formModel.IntPublicationYear" type="number" min="0" placeholder="出版年份" style="flex:1"/>
                <span style="margin-left:6px">年</span>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="合订期" prop="StrBoundIssue">
              <el-input v-model="formModel.StrBoundIssue" placeholder="请输入合订期"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="复本量" prop="IntNumberCopies">
              <el-input v-model="formModel.IntNumberCopies" type="number" min="0" placeholder="复本量"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="条码号" prop="StrBarcode">
              <el-input v-model="formModel.StrBarcode" placeholder="请输入条码号"/>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="摘要" prop="StrSummary">
              <el-input type="textarea" :rows="2" v-model="formModel.StrSummary" placeholder="请输入摘要"/>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="书屋" prop="StrLibraryID">
              <el-select
                  v-model="formModel.StrLibraryID"
                  placeholder="请选择书屋"
                  style="width:100%"
                  @change="libraryChange"
              >
                <el-option
                    v-for="item in swList"
                    :key="item.StrID"
                    :label="item.StrName"
                    :value="item.StrID"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="书架" prop="StrBookshelfID">
              <el-select
                  v-model="formModel.StrBookshelfID"
                  placeholder="请先选择书屋"
                  style="width:100%"
                  :disabled="!formModel.StrLibraryID"
                  clearable
                  @change="shelfChange"
              >
                <el-option
                    v-for="item in sjList"
                    :key="item.StrID"
                    :label="item.StrName"
                    :value="item.StrID"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-footer" style="float: right;">
        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="btnAddorMod">确定</el-button>
      </div>
      <p style="color: #ffffff">三阅</p>
    </el-dialog>
  </div>
</template>

<script>
import {BASE_URL} from "@/utils/constants";

export default {
  name: 'journaloldcatalog',
  data() {
    // 价格校验：允许空，非空须为不小于 0 的数字
    const validatePrice = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback();
      } else if (isNaN(value) || Number(value) < 0) {
        callback(new Error('请输入正确的价格'));
      } else {
        callback();
      }
    };
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        Page: 1,
        Perpage: 10,
        Sort: "-1",
        OrderBy: "DTCreatedDate",
        Search: {},
      },
      // 查询条件：ISSN 与正题名二选一，默认按 ISSN 查询
      queryField: 'StrISSN',
      queryValue: '',
      dialogFormVisible: false,
      dialogStatus: '',
      // 根据 ISSN 自动查询期刊源信息
      issnInfoLoading: false,
      lastQueriedIssn: '',
      textMap: {
        create: '新增过刊',
        update: '编辑过刊',
      },
      formModel: {},
      rules: {
        StrISSN: [
          {required: true, message: '请输入ISSN', trigger: 'blur'},
        ],
        StrPositiveTitle: [
          {required: true, message: '请输入正题名', trigger: 'blur'},
        ],
        FloatTotalPrice: [
          {required: true, message: '请输入总价', trigger: 'blur'},
          {validator: validatePrice, trigger: 'blur'},
        ],
        StrBarcode: [
          {required: true, message: '请输入条码号', trigger: 'blur'},
        ],
        StrLibraryID: [
          {required: true, message: '请选择书屋', trigger: 'change'},
        ],
      },
      // 书屋列表（GET librarys）
      swList: [],
      // 当前所选书屋下的书架列表（POST bookshelfs）
      sjList: [],
    };
  },
  created() {
    this.getList();
    this.getLibraryList();
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleString();
    },
    // 新增表单默认值
    getEmptyForm() {
      return {
        StrISSN: '',
        StrCN: '',
        FloatTotalPrice: '',
        StrPositiveTitle: '',
        StrSubtitle: '',
        StrParallelTitle: '',
        StrFirstResponsible: '',
        StrSecondResponsible: '',
        StrCollectiveResponsible: '',
        StrPublisherPlace: '',
        StrPublisher: '',
        IntPublicationYear: '',
        StrBoundIssue: '',
        StrSummary: '',
        IntNumberCopies: 1,
        StrBarcode: '',
        StrLibraryID: '',
        StrLibraryName: '',
        StrBookshelfID: '',
        StrBookshelfName: '',
      };
    },
    // 获取书屋列表
    getLibraryList() {
      this.$axios({
        url: BASE_URL + 'librarys',
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.swList = res.data.msg;
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          });
        }
      });
    },
    // 选择书屋时同步书屋名称，并联动加载该书屋的书架、清空已选书架
    libraryChange(val) {
      const lib = this.swList.find(item => item.StrID === val);
      this.formModel.StrLibraryName = lib ? lib.StrName : '';
      this.formModel.StrBookshelfID = '';
      this.formModel.StrBookshelfName = '';
      this.sjList = [];
      if (val) {
        this.getShelfList(val);
      }
    },
    // 根据书屋获取书架列表
    getShelfList(libraryID) {
      this.$axios({
        url: BASE_URL + 'bookshelfs',
        method: 'post',
        data: JSON.stringify({StrLibraryID: libraryID}),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.sjList = res.data.msg || [];
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          });
        }
      });
    },
    // 选择书架时同步书架名称
    shelfChange(val) {
      const shelf = this.sjList.find(item => item.StrID === val);
      this.formModel.StrBookshelfName = shelf ? shelf.StrName : '';
    },
    // 获取过刊列表
    getList() {
      this.listLoading = true;
      this.$axios({
        url: BASE_URL + 'oldjournals/search',
        method: 'post',
        data: JSON.stringify(this.listQuery),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok) {
          this.list = res.data.msg;
          this.total = res.data.total;
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          });
        }
        this.listLoading = false;
      }).catch(() => {
        this.listLoading = false;
      });
    },
    // 查询
    handleFilter() {
      const search = {};
      const value = this.queryValue.trim();
      if (value) search[this.queryField] = value;
      this.listQuery.Search = search;
      this.listQuery.Page = 1;
      this.getList();
    },
    // 重置查询
    resetFilter() {
      this.queryField = 'StrISSN';
      this.queryValue = '';
      this.listQuery.Search = {};
      this.listQuery.Page = 1;
      this.getList();
    },
    // 添加
    handleCreate() {
      this.formModel = this.getEmptyForm();
      this.sjList = [];
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.lastQueriedIssn = '';
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    // ISSN 输满 8 位数字后自动查询（兼容带连字符的 1234-5678 形式），与期刊订阅一致
    handleIssnInput() {
      if (this.dialogStatus !== 'create' || this.issnInfoLoading) return;
      const digits = (this.formModel.StrISSN || '').replace(/[^0-9]/g, '');
      if (digits.length === 8) {
        this.fetchIssnInfo();
      }
    },
    // 失焦兜底：带 X 校验位等非纯数字形式也能手动触发查询
    handleIssnBlur() {
      if (this.dialogStatus !== 'create' || this.issnInfoLoading) return;
      const raw = (this.formModel.StrISSN || '').trim();
      if (raw && raw !== this.lastQueriedIssn) {
        this.fetchIssnInfo();
      }
    },
    // 根据 ISSN 查询期刊登记源信息并回填（仅回填查询结果中有值的字段）
    fetchIssnInfo() {
      const issn = (this.formModel.StrISSN || '').trim();
      if (!issn || issn === this.lastQueriedIssn) return;
      this.issnInfoLoading = true;
      this.$axios({
        url: BASE_URL + 'journalregistrations/issnInfo',
        method: 'post',
        data: JSON.stringify({issn: issn}),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.ok && res.data.msg) {
          const msg = res.data.msg;
          // 期刊登记字段 -> 过刊字段
          const fieldMap = {
            StrISSN: 'StrISSN',
            StrCN: 'StrCN',
            StrJournalTitle: 'StrPositiveTitle',
            StrPublisher: 'StrPublisher',
            StrPublisherPlace: 'StrPublisherPlace',
            StrFirstResponsible: 'StrFirstResponsible',
            StrSecondResponsible: 'StrSecondResponsible',
          };
          const filled = [];
          Object.keys(fieldMap).forEach((src) => {
            const target = fieldMap[src];
            if (msg[src] !== null && msg[src] !== undefined && msg[src] !== '') {
              this.formModel[target] = msg[src];
              filled.push(target);
            }
          });
          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate(filled);
          });
          this.$message({type: 'success', message: '已自动填入查询到的期刊信息'});
        } else if (res.data.ok) {
          this.$message({type: 'warning', message: '未查询到该ISSN对应的期刊信息'});
        } else {
          this.$message({type: 'error', message: res.data.msg || '查询失败'});
        }
        // 回填后 ISSN 可能被接口值规范化（如带连字符形式），以最终值作为防重基准
        this.lastQueriedIssn = (this.formModel.StrISSN || '').trim() || issn;
        this.issnInfoLoading = false;
      }).catch(() => {
        this.issnInfoLoading = false;
        this.$message({type: 'error', message: '查询失败，请稍后重试'});
      });
    },
    // 编辑（列表行数据直接回显）
    handleUpdate(row) {
      this.formModel = {...row};
      this.sjList = [];
      // 加载该书屋的书架，保证已选书架能显示名称
      if (this.formModel.StrLibraryID) {
        this.getShelfList(this.formModel.StrLibraryID);
      }
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    // 确认添加或修改
    btnAddorMod() {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) return;
        const payload = {...this.formModel};
        // 数字字段提交前转换
        payload.IntPublicationYear = (payload.IntPublicationYear === '' || payload.IntPublicationYear === null || payload.IntPublicationYear === undefined)
            ? null : parseInt(payload.IntPublicationYear);
        payload.IntNumberCopies = (payload.IntNumberCopies === '' || payload.IntNumberCopies === null || payload.IntNumberCopies === undefined)
            ? 0 : parseInt(payload.IntNumberCopies);
        payload.FloatTotalPrice = (payload.FloatTotalPrice === '' || payload.FloatTotalPrice === null || payload.FloatTotalPrice === undefined)
            ? null : parseFloat(payload.FloatTotalPrice);

        const isCreate = this.dialogStatus === 'create';
        this.$axios({
          url: BASE_URL + (isCreate ? 'oldjournals/create' : 'oldjournals/update'),
          method: 'post',
          data: JSON.stringify(payload),
          headers: {
            'Content-Type': 'application/json',
            'dataType': 'json',
            'Authorization': localStorage.getItem("token"),
          },
        }).then((res) => {
          if (res.data.ok) {
            this.$message({
              message: isCreate ? '添加成功' : '编辑成功',
              type: 'success',
            });
            this.dialogFormVisible = false;
            this.getList();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              duration: 3000,
            });
          }
        });
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm('您确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.$axios({
          url: BASE_URL + 'oldjournals/delete',
          method: 'post',
          data: JSON.stringify({StrID: row.StrID}),
          headers: {
            'Content-Type': 'application/json',
            'dataType': 'json',
            'Authorization': localStorage.getItem("token"),
          },
        }).then((res) => {
          if (res.data.ok) {
            this.$notify({
              message: '删除成功',
              type: 'success',
              duration: 2000,
            });
            this.getList();
          } else {
            this.$notify({
              message: res.data.msg,
              type: 'error',
              duration: 2000,
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
    pageSizeChange(Perpage) {
      this.listQuery.Perpage = Perpage;
      this.getList();
    },
    currPageChange(Page) {
      this.listQuery.Page = Page;
      this.getList();
    },
  },
};
</script>
